module.exports = __webpack_public_path__ + "img/book-title-01.ebf8abe6.png";